import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FaUser, FaPhone, FaEnvelope, FaMapMarkerAlt, FaCity, FaComment } from 'react-icons/fa';
import './Order.css';
import Footer from './Footer';
import api from './api';

export default function Order() {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    email: '',
    address: '',
    city: '',
    message: ''
  });

  const [submitting, setSubmitting] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // Validate required fields
    if (!formData.name || !formData.phone || !formData.address || !formData.city) {
      alert('Please fill in all required fields (Name, Phone, Address, City)');
      return;
    }

    setSubmitting(true);

    try {
      // Call the backend API to submit the order
      const response = await api.post('/formOrder', {
        name: formData.name,
        phone: formData.phone,
        email: formData.email || null,
        address: formData.address,
        city: formData.city,
        message: formData.message || null
      });
      
      if (response.data?.status?.statusCode === 'code-200') {
        navigate('/order/thank-you', { 
          state: { fromFormSubmission: true } 
        });
      } else {
        alert('Failed to submit order. Please try again.');
      }
    } catch (error) {
      console.error('Error submitting order:', error);
      alert(error.response?.data?.status?.message || 'Something went wrong. Please try again.');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="order-page">
      <div className="order-hero">
        <h1 className="order-heading">Place Your Order</h1>
        <p className="order-para">Fill in your details and we'll get back to you soon!</p>
      </div>

      <div className="order-container">
        <div className="order-form-wrapper">
          <form className="order-form" onSubmit={handleSubmit}>
              <div className="form-section">
                <h3>Personal Information</h3>
                
                <div className="form-group">
                  <label htmlFor="name">
                    <FaUser className="label-icon" />
                    Full Name *
                  </label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    placeholder="Enter your full name"
                    required
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="phone">
                    <FaPhone className="label-icon" />
                    Phone Number *
                  </label>
                  <input
                    type="tel"
                    id="phone"
                    name="phone"
                    value={formData.phone}
                    onChange={handleChange}
                    placeholder="Enter your phone number"
                    required
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="email">
                    <FaEnvelope className="label-icon" />
                    Email Address
                  </label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    placeholder="Enter your email (optional)"
                  />
                </div>
              </div>

              <div className="form-section">
                <h3>Address Details</h3>
                
                <div className="form-group">
                  <label htmlFor="address">
                    <FaMapMarkerAlt className="label-icon" />
                    Address *
                  </label>
                  <textarea
                    id="address"
                    name="address"
                    value={formData.address}
                    onChange={handleChange}
                    placeholder="Enter your complete address"
                    rows={3}
                    required
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="city">
                    <FaCity className="label-icon" />
                    City *
                  </label>
                  <input
                    type="text"
                    id="city"
                    name="city"
                    value={formData.city}
                    onChange={handleChange}
                    placeholder="Enter your city"
                    required
                  />
                </div>
              </div>

              <div className="form-section">
                <h3>Additional Information</h3>
                
                <div className="form-group">
                  <label htmlFor="message">
                    <FaComment className="label-icon" />
                    Message
                  </label>
                  <textarea
                    id="message"
                    name="message"
                    value={formData.message}
                    onChange={handleChange}
                    placeholder="Any additional details or special instructions..."
                    rows={4}
                  />
                </div>
              </div>

              <div className="form-actions">
                <button 
                  type="submit" 
                  className="submit-btn"
                  disabled={submitting}
                >
                  {submitting ? 'Submitting...' : 'Submit Order'}
                </button>
              </div>
            </form>
        </div>
      </div>
      <Footer />
    </div>
  );
}

